import React from 'react';
import PropTypes from 'prop-types';
import { ALL_GOALS, EARMARK_ICONS, FALLBACK_ICON } from './EarmarkIconsConstants';
import { Icon } from './EarmarkIconsStyles';

const EarmarkIcons = ({ earmarks }) => {
  const icons = earmarks.map(({ Tooltip: tooltip, Type: type }, index) => {
    const earmarkType = type.toLowerCase();

    if (earmarkType === ALL_GOALS) {
      return (
        // eslint-disable-next-line react/no-array-index-key
        <span key={index}>
          {tooltip}
        </span>
      );
    }

    const currentIcon = EARMARK_ICONS.find(({ contains }) => earmarkType.indexOf(contains) > -1);

    const icon = currentIcon ? currentIcon.icon : FALLBACK_ICON;

    // eslint-disable-next-line react/no-array-index-key
    return <Icon key={index} className={icon} title={tooltip} />;
  });

  return <>{icons}</>;
};

EarmarkIcons.propTypes = {
  earmarks: PropTypes.arrayOf(
    PropTypes.shape({
      Type: PropTypes.string,
      Tooltip: PropTypes.string,
    }),
  ).isRequired,
};

export default EarmarkIcons;
